import React from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import ReactDOM from "react-dom";

class SelectChange_Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SubscriptionChange: this.props.getStore().SubscriptionChange,
      EventType: this.props.getStore().EventType,
      SubscriptionChangeError: null
    };
  }

  isValidated() {
    ((this.state.SubscriptionChange === "What would you like to do?") || (this.state.SubscriptionChange === ""))
        ? this.setState({
          SubscriptionChangeError: (
              <small className="text-danger">
                Please select what you would like to do.
              </small>
          )
        })
        : this.setState({SubscriptionChangeError: null});

    var change = ((this.state.SubscriptionChange !== "What would you like to do?") && (this.state.SubscriptionChange !== ""));
    const userInput = this._grabUserInput(); // grab user entered vals
    //Update the store with the data captured from this step
    this.props.updateStore({
      ...userInput,
      sentEmail: false
    });

    return (change);
  }

  _grabUserInput() {
    return {
      EventType: this.state.EventType,
      SubscriptionChange: ReactDOM.findDOMNode(this.subscriptionChange).value
    };
  }

  handleChangeSubscriptionEvent = () => {
    switch (ReactDOM.findDOMNode(this.subscriptionChange).value) {
      case "Update My Card Information":
        this.setState({ EventType: "Update_CC"});
        break;
      case "Reactivate My Subscription":
        this.setState({ EventType: "Reactivate"});
        break;
      case "Cancel My Subscription":
        this.setState({ EventType: "Cancel"});
        break;
      default:
        this.setState({ EventType: ""});
        break;
    }
    this.setState({ SubscriptionChange: ReactDOM.findDOMNode(this.subscriptionChange).value });
  };


  render() {
    return (
      <div className="wizard-step">
        <h5 className="text-center">What would you like to change about your subscription?</h5>
        <Row>
          <Col md={3} mdOffset={1}>
            <FormGroup>
              <ControlLabel>What would you like to do? <span className="text-danger">*</span> </ControlLabel>
              {(this.state.SubscriptionChangeError === null) ? (
                  <FormControl componentClass="select"
                               className="valid"
                               placeholder="What would you like to do?"
                               ref={subscriptionChange => { this.subscriptionChange= subscriptionChange }}
                               onChange={this.handleChangeSubscriptionEvent}
                               value={this.state.SubscriptionChange}
                  >
                    <option value="What would you like to do?">What would you like to do?</option>
                    <option value="Update My Card Information">Update Card Information</option>
                    <option value="Reactivate My Subscription">Reactivate My Subscription</option>
                    <option value="Cancel My Subscription">Cancel My Subscription</option>
                  </FormControl>
              ) : (
                  <FormControl componentClass="select"
                               className="error"
                               placeholder="What would you like to do?"
                               ref={subscriptionChange => { this.subscriptionChange= subscriptionChange }}
                               onChange={this.handleChangeSubscriptionEvent}
                               value={this.state.SubscriptionChange}
                  >
                    <option value="What would you like to do?">What would you like to do?</option>
                    <option value="Update My Card Information">Update Card Information</option>
                    <option value="Re-Activate My Subscription">Re-Activate My Subscription</option>
                    <option value="Cancel My Subscription">Cancel My Subscription</option>
                  </FormControl>
              )}
              {this.state.SubscriptionChangeError}
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SelectChange_Step1;



// WEBPACK FOOTER //
// ./src/views/Forms/ManageSubscriptionWizard/SelectChange_Step1.jsx